<div class="row" style="display:block;">
    <div class="row">
        <div *ngIf="hospitalSystems.length" class="selected-system-label">
            <ng-select name="hospitalSystem" class="auto-grow" [searchable]="false" [clearable]="false"
                [(ngModel)]="selectedSystemName" (change)="systemNameChanged()" [items]="hospitalSystems"
                placeholder="Select System" [readonly]="readonly">
            </ng-select>
        </div>
    </div>
</div>